import React, { useState, Fragment, useEffect } from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import { Button, Table, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faDollarSign } from '@fortawesome/free-solid-svg-icons'

import PlanoTratamentoService from '../../../services/planoTratamento.service'
import { TIPOS_TEMPLATE } from '../../../constants/template.constants'
import { statusPlano, MSG_LIMITE_RENEGOCIACOES, cargoConstant } from '../../../constants/common.constants'
import SystemConstants from '../../../constants/system.constants'
import NegativacaoStatusBadge from '../../Common/NegativacaoStatusBadge'
import TransferirResponsavelModal from '../../Common/TransferirResponsavelModal'
import { toast } from 'react-toastify'


import { printParcelasReceipt } from '../../Templates/PrintableReceipt'
import { format } from 'date-fns'
const PERFIL_COBRANCA_JURIDICO = 'c397f706-9840-4499-5524-08da8abab7cf';

const PacientePlanosTratamento = (props) => {
  const { passos, onChangeStep, planosTratamentoList: planosTratamentoListProp, onRefreshPlanos } = props
  const planosTratamentoList = Array.isArray(planosTratamentoListProp) ? planosTratamentoListProp : []
  const [menuPrintAnchorEl, setPrintMenuAnchorEl] = useState(null)
  const [selectedPrintMenu, setSelectedPrintMenu] = useState(null)
  const [menuFinancialAnchorEl, setFinancialMenuAnchorEl] = useState(null)
  const [selectedFinancialMenu, setSelectedFinancialMenu] = useState(null)
  const [podeRenegociarComParceiro, setPodeRenegociarComParceiro] = useState(false)

  const [menuProteticoMenuAnchorEl, setProteticoMenuAnchorEl] = useState(null)
  const [selectedProteticoMenu, setSelectedProteticoMenu] = useState(null)

  const [selectedPlanoTratamentoId, setSelectedPlanoTratamentoId] = useState(null)

  const [proteticosRenegociados, setProteticosRenegociados] = useState([])
  const [parcelasProteticoEmAberto, setParcelasProteticoEmAberto] = useState([])
  const [planoTransferencia, setPlanoTransferencia] = useState(null)

  const user = JSON.parse(localStorage.getItem(SystemConstants.getUser()))
  const isAdmin = user.podeAlternarConta
  const isAdminCargo = user.tipoCargo == cargoConstant.ADMINISTRADOR.value

  const handleOpenPrintMenu = async (event, index, planoTratamentoId) => {
    setPrintMenuAnchorEl(event.target)
    setSelectedPrintMenu(index)
    setSelectedPlanoTratamentoId(planoTratamentoId)

    await getPagamentosRenegociadosProtetico(planoTratamentoId)
  }

  const getPagamentosRenegociadosProtetico = async (planoTratamentoId) => {
    const { data } = await PlanoTratamentoService.getPagamentosRenegociadosProtetico(planoTratamentoId)
    setProteticosRenegociados(data)
  }

  const handlePrintClick = async (planoTratamentoId, tipoTemplate) => {
    handleClosePrintMenu()
    await PlanoTratamentoService.downloadTemplateAsPDF(planoTratamentoId, tipoTemplate)
  }

  const handleClosePrintMenu = () => {
    setPrintMenuAnchorEl(null)
    setSelectedPrintMenu(null)
  }

  const handleOpenFinancialMenu = (event, index, planoTratamentoId) => {
    setFinancialMenuAnchorEl(event.target)
    setSelectedFinancialMenu(index)

    getParcelasProteticoEmAberto(planoTratamentoId)
  }

  const getParcelasProteticoEmAberto = async (planoTratamentoId) => {
    const { data } = await PlanoTratamentoService.getParcelasEmAberto(planoTratamentoId, true, true)
    setParcelasProteticoEmAberto(data.parcelasProteticas)
  }

  const handleCloseFinancialMenu = () => {
    setFinancialMenuAnchorEl(null)
    setSelectedFinancialMenu(null)
  }

  const handleStepChange = (plano, step) => {
    onChangeStep(plano, step)
    handleCloseFinancialMenu()
  }

  const handleRenegociarClick = (plano, step) => {
    if (!plano.comParceiroFinanceiro && plano.atingiuLimiteRenegociacoes) {
      toast(MSG_LIMITE_RENEGOCIACOES, { type: toast.TYPE.WARNING })
      handleCloseFinancialMenu()
      return
    }
    handleStepChange(plano, step)
  }

  const podeExibirRenegociar = (plano) =>
    plano.podeRenegociar && (plano.comParceiroFinanceiro || !plano.atingiuLimiteRenegociacoes)

  const podeExibirRenegociarAdmin = (plano) =>
    plano.comParceiroFinanceiro || !plano.atingiuLimiteRenegociacoes

  const podeExibirRenegociarProtetico = (plano) =>
    parcelasProteticoEmAberto.length > 0 && (plano.comParceiroFinanceiro || !plano.atingiuLimiteRenegociacoes)

  /***** INIT PROTETICO *****/

  const handleOpenProteticoMenu = (event, index) => {
    setProteticoMenuAnchorEl(event.target)
    setSelectedProteticoMenu(index)
  }

  const handleCloseProteticoMenu = () => {
    setProteticoMenuAnchorEl(null)
    setSelectedProteticoMenu(null)
  }

  const handleProteticoClick = async (planoTratamentoId, parcelamentoRenegociadoId) => {
    handleCloseProteticoMenu()
    await PlanoTratamentoService.downloadTemplateAsPDFByParteNome(planoTratamentoId, TIPOS_TEMPLATE.TermoDeRenegociacaoProtetico, parcelamentoRenegociadoId)
  }

  /***** END PROTETICO *****/

  const getStatusLabel = (status) => {
    const statusPlanoTratamento = Object.values(statusPlano).find((s) => s.value === status)
    return statusPlanoTratamento && statusPlanoTratamento.label ? statusPlanoTratamento.label : ''
  }

  const handlePrintParcelamento = async (plano) => {
    const pagamentoPlano = plano.pagamentos[plano.pagamentos.length - 1]
    const procedimentosProteticos = plano.procedimentos.filter((proc) => !!proc.planoTratamentoProcedimentoProtetico)

    const pagProteticosAux = procedimentosProteticos
      .map(
        (proc) =>
          proc.planoTratamentoProcedimentoProtetico.planoTratamentoPagamentoProteticoAtual
      )

    const pagProteticos = pagProteticosAux.filter((proc) => !!proc)

    let dente = ''
    const nomeProtese = []
    plano.procedimentos.map(procedimento => {
      if (procedimento.planoTratamentoProcedimentoProteticoId) {
        if (procedimento.dente)
          dente = ' - Dente: ' + procedimento.dente.codigo

        nomeProtese.push({ 'id': procedimento.planoTratamentoProcedimentoProteticoId, 'nome': procedimento.planoTratamentoProcedimentoProtetico.procedimentoProtetico.nome + dente })

        dente = ''
      }
    });

    const receipt = {
      numeroPlano: plano.numeroPlano,
      nomeContratante: plano.paciente.nome,
      nomePaciente: plano.dependente ? plano.dependente.nome : plano.paciente.nome

    }

    printParcelasReceipt({
      ...receipt,
      parcelas: pagamentoPlano.parcelas,
      valorTotal: pagamentoPlano.valorTotal,
    })

    pagProteticos.forEach((pagamento) => {
      printParcelasReceipt({
        ...receipt,
        nomeProtese: pagamento.planoTratamentoProcedimentoProteticoId ? nomeProtese.find((x) => x.id == pagamento.planoTratamentoProcedimentoProteticoId).nome : '',
        parcelas: pagamento.parcelas,
        valorTotal: pagamento.valorTotal,
        type: 'protese'
      })
    })
  }

  useEffect(() => {
    setPodeRenegociarComParceiro(user.perfilId == PERFIL_COBRANCA_JURIDICO)
  }, [])

  const renderAcoesPlano = (plano, index) => (
    <div className='d-flex flex-wrap justify-content-center justify-content-md-between align-items-center'>
                <Button onClick={(event) => handleOpenFinancialMenu(event, index, plano.id)} variant='primary' size='sm' style={{ width: '32px', height: '32px', marginRight: '5px' }}>
                  <FontAwesomeIcon icon={faDollarSign} />
                </Button>
                <Menu
                  anchorEl={menuFinancialAnchorEl}
                  open={selectedFinancialMenu === index}
                  onClose={handleCloseFinancialMenu}
                  keepMounted
                >
                  {isAdmin &&
                    <MenuItem onClick={() => handleStepChange(plano, passos.VENCIMENTO)}>Alterar Vencimento</MenuItem>
                  }
                  {(!podeRenegociarComParceiro && !plano.comParceiroFinanceiro && !isAdmin) &&

                    <>
                    {(!plano.paciente || !plano.paciente.negativado || (plano.paciente.negativado && !plano.podeRenegociar)) &&
                        <MenuItem onClick={() => handleStepChange(plano, passos.PAGAR)}>Realizar Pagamento</MenuItem>}

                      {podeExibirRenegociar(plano) &&
                        <MenuItem onClick={() => handleRenegociarClick(plano, passos.RENEGOCIAR)}>Renegociar Plano</MenuItem>}
                    </>
                  }

                  {isAdmin &&
                    <>
                      <MenuItem onClick={() => handleStepChange(plano, passos.PAGAR)}>Realizar Pagamento</MenuItem>
                      {podeExibirRenegociarAdmin(plano) &&
                        <MenuItem onClick={() => handleRenegociarClick(plano, passos.RENEGOCIAR)}>Renegociar Plano</MenuItem>}
                    </>
                  }

                  {(podeRenegociarComParceiro && plano.comParceiroFinanceiro && !isAdmin) &&
                    <>
                      <MenuItem onClick={() => handleStepChange(plano, passos.PAGAR)}>Realizar Pagamento</MenuItem>
                      <MenuItem onClick={() => handleRenegociarClick(plano, passos.RENEGOCIAR)}>Renegociar Plano</MenuItem>
                    </>
                  }

                  {podeExibirRenegociarProtetico(plano) &&
                    <MenuItem onClick={() => handleRenegociarClick(plano, passos.RENEGOCIAR_PROT)}>Renegociar Protético</MenuItem>
                  }

                  {isAdmin &&
                    <MenuItem onClick={() => handleStepChange(plano, passos.CANCELAR_PROC)}>
                      Cancelar Procedimento
                    </MenuItem>
                  }

                  {isAdmin &&
                    <MenuItem onClick={() => handleStepChange(plano, passos.CANCELAR_PAG)}>Cancelar Pagamento</MenuItem>
                  }

                  <MenuItem onClick={() => handleStepChange(plano, passos.VISUALIZAR_AVAL)}>
                    Visualizar Avaliação
                  </MenuItem>
                  <MenuItem onClick={() => handleStepChange(plano, passos.VISUALIZAR_PROCED)}>
                    Visualizar Procedimentos
                  </MenuItem>
                  <MenuItem onClick={() => handleStepChange(plano, passos.VISUALIZAR_PARC)}>
                    Visualizar Parcelas
                  </MenuItem>

                  {!podeRenegociarComParceiro && !isAdmin &&
                    <MenuItem onClick={() => handleStepChange(plano, passos.ALTERAR_PROT)}>Alterar Protético</MenuItem>
                  }

                  {isAdminCargo &&
                    <MenuItem onClick={() => {
                      handleCloseFinancialMenu()
                      setPlanoTransferencia(plano)
                    }}>
                      Transferir Responsável
                    </MenuItem>
                  }
                </Menu>
                <Button onClick={(event) => handleOpenPrintMenu(event, index, plano.id)} variant='primary' size='sm' style={{ width: '32px', height: '32px' }}>
                  <FontAwesomeIcon icon={faPrint} />
                </Button>
                <Menu
                  anchorEl={menuPrintAnchorEl}
                  open={selectedPrintMenu === index}
                  onClose={handleClosePrintMenu}
                  keepMounted
                >
                  <MenuItem onClick={() => handlePrintParcelamento(plano)}>Parcelamento</MenuItem>
                  <MenuItem onClick={() => handlePrintClick(plano.id, TIPOS_TEMPLATE.Contrato)}>
                    Contrato de Prestação de Serviços
                  </MenuItem>
                  <MenuItem onClick={() => handlePrintClick(plano.id, TIPOS_TEMPLATE.AnexoContrato)}>
                    Anexo do Contrato
                  </MenuItem>
                  <MenuItem onClick={() => handlePrintClick(plano.id, TIPOS_TEMPLATE.TermoDeConsentimentoDeTratamento)}>
                    Termo de Consentimento de Tratamento
                  </MenuItem>
                  {plano.statusTratamento === statusPlano.FINALIZADO.value && (
                    <MenuItem onClick={() => handlePrintClick(plano.id, TIPOS_TEMPLATE.TermoDeConclusaoDeTratamento)}>
                      Termo de Conclusão de Tratamento
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() =>
                      handlePrintClick(plano.id, TIPOS_TEMPLATE.TermoDeCancelamentoDeProcedimentoComPendencia)
                    }
                  >
                    Termo de Cancelamento com Confissão de Dívida
                  </MenuItem>
                  <MenuItem
                    onClick={() =>
                      handlePrintClick(plano.id, TIPOS_TEMPLATE.TermoDeCancelamentoDeProcedimentoComQuitacao)
                    }
                  >
                    Termo de Cancelamento com Quitação
                  </MenuItem>
                  <MenuItem onClick={() => handlePrintClick(plano.id, TIPOS_TEMPLATE.TermoDeRenegociacao)}>
                    Termo de Renegociação
                  </MenuItem>
                  <MenuItem onClick={() => handlePrintClick(plano.id, TIPOS_TEMPLATE.RespostasAnamnese)}>
                    Anamnese
                  </MenuItem>

                  {proteticosRenegociados.length > 0 &&
                    <MenuItem onClick={(event) => handleOpenProteticoMenu(event, index)} >
                      Termo de Renegociação de Protético
                    </MenuItem>
                  }
                  <Menu
                    anchorEl={menuProteticoMenuAnchorEl}
                    open={selectedProteticoMenu === index}
                    onClose={handleCloseProteticoMenu}
                    keepMounted
                  >
                    {proteticosRenegociados.map((proteticoRenegociado, index) => (
                      <MenuItem onClick={() => handleProteticoClick(plano.id, proteticoRenegociado.id)}>{proteticoRenegociado.planoTratamentoProcedimentoProtetico.procedimentoProtetico.nome + (proteticoRenegociado.planoTratamentoProcedimentoProtetico.dente ? ' - ' + proteticoRenegociado.planoTratamentoProcedimentoProtetico.dente.codigo : '')}</MenuItem>
                    ))}
                  </Menu>

                </Menu>
              </div>
  )

  const renderTable = () => (
    <Table bordered hover style={{ backgroundColor: 'white' }}>
      <thead>
        <tr className='text-center'>
          <th>Número do Plano</th>
          <th>Paciente</th>
          <th>Iniciado em</th>
          <th>Cancelado em</th>
          <th>Status</th>
          <th>Data de finalização</th>
          <th width='100px'>Ações</th>
        </tr>
      </thead>
      <tbody>
        {planosTratamentoList.map((plano, index) => (
          <tr className='text-center' key={index}>
            <td>{plano.numeroPlano}{plano.comParceiroFinanceiro && <><br /><span className='badge badge-danger'>Com Parceiro</span></>}{plano.statusNegativacao != null && plano.statusNegativacao !== 3 && <><br /><NegativacaoStatusBadge status={plano.statusNegativacao} /></>}</td>
            <td>
              <div>{plano.dependenteId ? (plano.dependente && plano.dependente.nome) : (plano.paciente && plano.paciente.nome)}</div>
              {plano.nomeColaboradorResponsavel && (
                <small className='text-muted text-uppercase'>
                  Resp.: {plano.nomeColaboradorResponsavel}
                </small>
              )}
            </td>
            <td>{format(new Date(plano.dataCriacao), 'dd/MM/yyyy')}</td>
            <td>{plano.dataCancelamento !== null ? format(new Date(plano.dataCancelamento), 'dd/MM/yyyy') : '-'}</td>
            <td>{getStatusLabel(plano.statusTratamento)}</td>
            {plano.dataFinalizacao ? (
              <td>
                <p className='m-0'>{format(new Date(plano.dataFinalizacao), 'dd/MM/yyyy')}</p>
                <p className='m-0'>{format(new Date(plano.dataFinalizacao), 'HH:mm')}</p>
              </td>
            ) : (
              <td>-</td>
            )}
            <td>{renderAcoesPlano(plano, index)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )

  const renderMobileCards = () =>
    planosTratamentoList.map((plano, index) => (
      <Card key={index} className='mb-3 shadow-sm border plano-tratamento-card-mobile'>
        <Card.Body className='p-3'>
          <div className='font-weight-bold text-dark mb-2'>
            Plano {plano.numeroPlano}
            {plano.comParceiroFinanceiro && (
              <span className='badge badge-danger ml-2'>Com Parceiro</span>
            )}
            {plano.statusNegativacao != null && plano.statusNegativacao !== 3 && (
              <NegativacaoStatusBadge status={plano.statusNegativacao} className='ml-2' />
            )}
          </div>
          <div className='small'>
            <div className='d-flex justify-content-between py-2 border-bottom'>
              <span className='text-muted'>Paciente</span>
              <span className='text-dark text-right'>
                <div>{plano.dependenteId ? (plano.dependente && plano.dependente.nome) : (plano.paciente && plano.paciente.nome)}</div>
                {plano.nomeColaboradorResponsavel && (
                  <small className='text-muted text-uppercase d-block'>
                    Resp.: {plano.nomeColaboradorResponsavel}
                  </small>
                )}
              </span>
            </div>
            <div className='d-flex justify-content-between py-2 border-bottom'>
              <span className='text-muted'>Iniciado em</span>
              <span className='text-dark'>{format(new Date(plano.dataCriacao), 'dd/MM/yyyy')}</span>
            </div>
            <div className='d-flex justify-content-between py-2 border-bottom'>
              <span className='text-muted'>Cancelado em</span>
              <span className='text-dark'>{plano.dataCancelamento !== null ? format(new Date(plano.dataCancelamento), 'dd/MM/yyyy') : '-'}</span>
            </div>
            <div className='d-flex justify-content-between py-2 border-bottom'>
              <span className='text-muted'>Status</span>
              <span className='text-dark text-right'>{getStatusLabel(plano.statusTratamento)}</span>
            </div>
            <div className='d-flex justify-content-between py-2 border-bottom'>
              <span className='text-muted'>Finalização</span>
              <span className='text-dark text-right'>
                {plano.dataFinalizacao ? (
                  <>
                    {format(new Date(plano.dataFinalizacao), 'dd/MM/yyyy')}{' '}
                    {format(new Date(plano.dataFinalizacao), 'HH:mm')}
                  </>
                ) : (
                  '-'
                )}
              </span>
            </div>
          </div>
          <div className='mt-3 pt-2 border-top'>{renderAcoesPlano(plano, index)}</div>
        </Card.Body>
      </Card>
    ))

  return (
    <Fragment>
      {planosTratamentoList.length > 0 ? (
        <>
          <div className='d-none d-md-block table-responsive'>{renderTable()}</div>
          <div className='d-md-none'>{renderMobileCards()}</div>
        </>
      ) : (
        <div>Nenhum plano encontrado para este paciente.</div>
      )}

      <TransferirResponsavelModal
        show={!!planoTransferencia}
        onHide={() => setPlanoTransferencia(null)}
        plano={planoTransferencia}
        tipoPlano='Clínico'
        onSuccess={onRefreshPlanos}
      />
    </Fragment>
  )
}

export default PacientePlanosTratamento
